import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export default class KeywordAccessRight {
  public static VIEW_KEYWORDS: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel <= 2 || menuDisplayLevel >= 4;
  public static CAN_EDIT_MANDATORY_KEYWORD: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel === 0;
  public static UPDATE_KEYWORD_UNSUBSCRIBE_RESPONSE: AuthenticationAccessRight =
    ({ menuDisplayLevel }) => menuDisplayLevel === 0;
}
